import Nav from "@/components/cobain/Nav";
import Hero from "@/components/cobain/Hero";
import Marquee from "@/components/cobain/Marquee";
import Reach from "@/components/cobain/Reach";
import Latest from "@/components/cobain/Latest";
import Watch from "@/components/cobain/Watch";
import MediaBanner from "@/components/cobain/MediaBanner";
import MusicPlayer from "@/components/cobain/MusicPlayer";
import Streaming from "@/components/cobain/Streaming";
import Read from "@/components/cobain/Read";
import Shop from "@/components/cobain/Shop";
import Team from "@/components/cobain/Team";
import NewsletterBand from "@/components/cobain/NewsletterBand";
import Partner from "@/components/cobain/Partner";
import Footer from "@/components/cobain/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Nav />
      <Hero />
      <Marquee />
      <Reach />
      <Latest />
      <Watch />
      <MediaBanner />
      <MusicPlayer />
      <Streaming />
      <Read />
      <Shop />
      <Team />
      <NewsletterBand />
      <Marquee dark fast items={["PARTNERSHIPS OPEN", "SPONSORSHIPS", "CULTURE CAMPAIGNS", "PREMIERES", "ADVERTISING", "PRODUCT FEATURES"]} />
      <Partner />
      <Footer />
    </main>
  );
}
